export const LANGUAGES = [
  { code: "en", name: "English", native: "English", tts: "en-US" },
  { code: "es", name: "Spanish", native: "Español", tts: "es-ES" },
  { code: "fr", name: "French", native: "Français", tts: "fr-FR" },
  { code: "de", name: "German", native: "Deutsch", tts: "de-DE" },
  { code: "it", name: "Italian", native: "Italiano", tts: "it-IT" },
  { code: "pt", name: "Portuguese", native: "Português", tts: "pt-BR" },
  { code: "nl", name: "Dutch", native: "Nederlands", tts: "nl-NL" },
  { code: "sv", name: "Swedish", native: "Svenska", tts: "sv-SE" },
  { code: "no", name: "Norwegian", native: "Norsk", tts: "nb-NO" },
  { code: "da", name: "Danish", native: "Dansk", tts: "da-DK" },
  { code: "fi", name: "Finnish", native: "Suomi", tts: "fi-FI" },
  { code: "pl", name: "Polish", native: "Polski", tts: "pl-PL" },
  { code: "cs", name: "Czech", native: "Čeština", tts: "cs-CZ" },
  { code: "ro", name: "Romanian", native: "Română", tts: "ro-RO" },
  { code: "hu", name: "Hungarian", native: "Magyar", tts: "hu-HU" },
  { code: "el", name: "Greek", native: "Ελληνικά", tts: "el-GR" },
  { code: "ru", name: "Russian", native: "Русский", tts: "ru-RU" },
  { code: "uk", name: "Ukrainian", native: "Українська", tts: "uk-UA" },
  { code: "tr", name: "Turkish", native: "Türkçe", tts: "tr-TR" },
  { code: "ar", name: "Arabic", native: "العربية", tts: "ar-SA", rtl: true },
  { code: "he", name: "Hebrew", native: "עברית", tts: "he-IL", rtl: true },
  { code: "fa", name: "Persian", native: "فارسی", tts: "fa-IR", rtl: true },
  { code: "ur", name: "Urdu", native: "اردو", tts: "ur-PK", rtl: true },
  { code: "hi", name: "Hindi", native: "हिन्दी", tts: "hi-IN" },
  { code: "bn", name: "Bengali", native: "বাংলা", tts: "bn-IN" },
  { code: "pa", name: "Punjabi", native: "ਪੰਜਾਬੀ", tts: "pa-IN" },
  { code: "ta", name: "Tamil", native: "தமிழ்", tts: "ta-IN" },
  { code: "te", name: "Telugu", native: "తెలుగు", tts: "te-IN" },
  { code: "ml", name: "Malayalam", native: "മലയാളം", tts: "ml-IN" },
  { code: "kn", name: "Kannada", native: "ಕನ್ನಡ", tts: "kn-IN" },
  { code: "mr", name: "Marathi", native: "मराठी", tts: "mr-IN" },
  { code: "gu", name: "Gujarati", native: "ગુજરાતી", tts: "gu-IN" },
  { code: "zh-CN", name: "Chinese (Simplified)", native: "中文（简体）", tts: "zh-CN" },
  { code: "zh-TW", name: "Chinese (Traditional)", native: "中文（繁體）", tts: "zh-TW" },
  { code: "ja", name: "Japanese", native: "日本語", tts: "ja-JP" },
  { code: "ko", name: "Korean", native: "한국어", tts: "ko-KR" },
  { code: "vi", name: "Vietnamese", native: "Tiếng Việt", tts: "vi-VN" },
  { code: "th", name: "Thai", native: "ไทย", tts: "th-TH" },
  { code: "id", name: "Indonesian", native: "Bahasa Indonesia", tts: "id-ID" },
  { code: "ms", name: "Malay", native: "Bahasa Melayu", tts: "ms-MY" },
  { code: "fil", name: "Filipino", native: "Filipino", tts: "fil-PH" },
  { code: "sw", name: "Swahili", native: "Kiswahili", tts: "sw-KE" },
  { code: "yo", name: "Yoruba", native: "Yorùbá", tts: "yo-NG" },
  { code: "ha", name: "Hausa", native: "Hausa", tts: "ha-NG" },
  { code: "am", name: "Amharic", native: "አማርኛ", tts: "am-ET" },
  { code: "zu", name: "Zulu", native: "isiZulu", tts: "zu-ZA" },
];
